// services/passwordService.js
//
// Cliente dos endpoints públicos de recuperação de senha.
// Ambos são não autenticados — o `http` só não anexa o Bearer quando não há
// token, então usá-lo aqui é seguro e mantém baseURL/tratamento de 429.

import http from "@/services/http";

/**
 * Dispara o e-mail com o link de redefinição.
 * @param {string} email
 * @returns {Promise<string>} mensagem de sucesso do backend
 */
export async function requestPasswordReset(email) {
  const { data } = await http.post("/api/forgot-password", { email });
  return data?.message || "Link de recuperação enviado para seu e-mail.";
}

/**
 * Redefine a senha usando o token recebido por e-mail.
 * @param {Object} args
 * @param {string} args.token
 * @param {string} args.email
 * @param {string} args.password
 * @param {string} args.passwordConfirmation
 * @returns {Promise<string>} mensagem de sucesso do backend
 */
export async function resetPassword({
  token,
  email,
  password,
  passwordConfirmation,
}) {
  const { data } = await http.post("/api/reset-password", {
    token,
    email,
    password,
    password_confirmation: passwordConfirmation,
  });
  return data?.message || "Senha redefinida com sucesso.";
}

/**
 * Extrai a primeira mensagem de erro útil de uma resposta do Laravel,
 * que varia entre { error }, { message } e { errors: { campo: [...] } }.
 */
export function extractPasswordError(err, fallback) {
  const data = err?.response?.data;
  if (!data) return fallback;
  if (typeof data.error === "string") return data.error;
  if (data.errors && typeof data.errors === "object") {
    const first = Object.values(data.errors)[0];
    if (Array.isArray(first) && first.length) return first[0];
  }
  if (typeof data.message === "string") return data.message;
  return fallback;
}
